import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: '2',
    view: 'feed',
  },
  itemDesign: {},
  containerDesign: {},

  activeItem: {},
};

export const digitalSlice = createSlice({
  name: 'digital',
  initialState,
  reducers: {
    digitalStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#ECECF0',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: String(blockDesign.layout) ?? '2',
        view: blockDesign.view ?? 'feed',
      };
    },
    digitalClear: () => initialState,

    digitalUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    digitalUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    digitalUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    digitalUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    digitalUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
  },
});

export const { digitalStore, digitalClear, digitalUpdateIsLoading, digitalUpdateIsActive, digitalUpdateBlockContent, digitalUpdateBlockDesign, digitalUpdateActiveItem } =
  digitalSlice.actions;

export const selectDigitalIsLoading = (state) => state.digital.isLoading;

export const selectDigitalId = (state) => state.digital.id;
export const selectDigitalUID = (state) => state.digital.uid;
export const selectDigitalSID = (state) => state.digital.sid;

export const selectDigitalBlockContent = (state) => state.digital.blockContent;
export const selectDigitalBlockDesign = (state) => state.digital.blockDesign;
export const selectDigitalSortItems = createSelector([selectDigitalBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectDigitalItemDesign = (state) => state.digital.itemDesign;
export const selectDigitalContainerDesign = (state) => state.digital.containerDesign;

export const selectDigitalActiveItem = (state) => state.digital.activeItem;

export default digitalSlice.reducer;
